import { NgModule } from '@angular/core';
import { HeaderComponent } from './header.component';
import { MatToolbarModule } from '@angular/material/toolbar'; 
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon'; 
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
    imports: [MatToolbarModule,CommonModule,MatIconModule,FlexLayoutModule],
    exports: [HeaderComponent],
    declarations: [HeaderComponent],
    providers: [],
})
export class HeaderModule { }
